define('viewmodels/site/index',['jquery', 'plugins/router', './__subrouter', 'lodash', 'moment', 'atn/atn',
	'dataSource/oemMessages','dataSource/uiVersion'], 
	function($, router, subrouter, _, moment, atn, oemMessages, uiVersion) {
	'use strict';

	return {
		activate: activate,
		router: subrouter,
		generateCopyrightString: generateCopyrightString,
		patentInfo: atn.config.messages.loginPage.brandPatentInfo,
		patentHeader: atn.config.messages.loginPage.patentHeader,
		rebrandingResources: atn.config.oemResourcesMap,
		uiVersion:uiVersion.uiVersion,
		rebrandingMessages: oemMessages.oemMessages,
        rebrandingFolder: atn.config.oemRebrandingFolder
	};

	function activate() {

	}

	
	// This function will generate Copyright string displayed on all login/logout/error pages on GAMS UI
	// get year displayed in copyright string from current date.
	function generateCopyrightString() {
		var todaysDate = new Date(),
			returnVal;
		todaysDate = moment(todaysDate).format('YYYY');
		returnVal = atn.utils.sformat(atn.config.messages.loginPage.copyrightString,
		 todaysDate);
		return returnVal;
	}
});
